import { denormalizePlotDateTimeFromApiResponse, prepareChart } from "services";

// POST /order/status-history/graph/venue/{id} -- single count per bucket, so this reuses
// the exact same chart pipeline as the sales dashboard's line charts (same plot shape,
// same bucket-format strings on both ends).
export const orderVolumeGraph = {
  data: {
    transform: ({ src, params }) => {
      const plot = denormalizePlotDateTimeFromApiResponse(src?.plot || [], params.interval);
      return prepareChart(plot);
    },
  },
};

// POST /order/status-history/kpi/venue/{id}
export const orderStatusKpi = {
  totalOrders: { key: "totalOrders" },
  avgItemsPerOrder: { key: "avgItemsPerOrder" },
  avgDurationSecondsByStatus: { key: "avgDurationSecondsByStatus" },
  currentStatusDistribution: { key: "currentStatusDistribution" },
};
